'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'diamond';
var width = 512;
var height = 512;
var aliases = [9830];
var unicode = 'f219';
var svgPathData = 'M0 256l33.9 33.9L222.1 478.1 256 512l33.9-33.9L478.1 289.9 512 256l-33.9-33.9L289.9 33.9 256 0 222.1 33.9 33.9 222.1 0 256zM256 444.1L67.9 256 256 67.9 444.1 256 256 444.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamond = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;